import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const CallbackHandler: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');

    const stored = localStorage.getItem('callbackFlowData');

    if (!stored) {
      navigate('/', { replace: true });
      return;
    }

    const flowData = JSON.parse(stored);

    if (code) {
      flowData.oauthCode = code;
      localStorage.setItem('callbackFlowData', JSON.stringify(flowData));
    } else {
      console.warn('No OAuth code found in query params.');
    }

    if (flowData.returnUrl) {
      window.location.href = flowData.returnUrl;
    } else {
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default CallbackHandler;
